<template>
  <div>
    <Headers :windowWidth="windowWidth"/> 
    <div class="detail">
        <!-- 顶部面包屑 -->
        <div class="top_box">
            <div class="title1" @click="gotoback">{{$t('detail.carbonProject')}}</div>
            <div class="title2">/</div>
            <div class="title3">{{$t('detail.projectDetail')}}</div>
        </div>
        <div>
            <el-row type="flex" class="nfdtTitle">
                <el-col> {{ $t("carbonIndex.nfdtId") }}: </el-col>
            </el-row>
            <el-row type="flex" class="nfdtTitle">
                <el-col> {{ $t("carbonIndex.nfdtName") }}: </el-col>
            </el-row>
        </div>
        <div>
        <table border="1" class="tabel_box" style="border-collapse: collapse;">
            <tr>
                <th>{{$t('carbonIndex.offsetId')}}</th>
                <td>1234</td>
            </tr>
            <tr>
                <th>{{$t('carbonIndex.offsetName')}}</th>
                <td>Carbon Project</td>
            </tr>
            <tr>
                <th>{{$t('carbonIndex.description')}}</th>
                <td>xfkd25lsjddas524oodhshaudi54dsadhsjshshus1ashs</td>
            </tr>
            <tr>
                <th>{{$t('carbonIndex.ContractAddress')}}</th>
                <td>xfkd25lsjddas524oodhshaudi54dsadhsjshshus1ashs</td>
            </tr>
            <tr>
                <th>{{$t('carbonIndex.ReceiverAddress')}}</th>
                <td>xfkd25lsjddas524oodhshaudi54dsadhsjshshus1ashs</td>
            </tr>
            <tr>
                <th>{{$t('carbonIndex.NameOfReport')}}</th>
                <td>xfkd25lsjddas524oodhshaudi54dsadhsjshshus1ashs</td>
            </tr>
        </table>
        <!-- <el-table
            :data="
            tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
            "
            stripe
            :header-cell-style="{
            background: '#F0F3F6',
            color: '#626262',
            fontSize: '14px',
            fontFamily: 'ArialMT',
            paddingTop: '17px',
            paddingBottom: '15px',
            paddingLeft: '20px',
            }"
            :cell-style="columnStyle"
            
            style="width: 100%"
        >
            <template slot="empty">
            <p style="margin-top: 50px">
                <img class="data-pic" src="../../assets/img/noData.png" alt="" />
            </p>
            <p class="nodata">No data</p>
            </template>
            <el-table-column prop="id" :label="$t('carbonIndex.offsetId')">
            </el-table-column>
            <el-table-column prop="name" :label="$t('carbonIndex.offsetName')">
            </el-table-column>
            <el-table-column prop="quantity" :label="$t('carbonIndex.description')">
            </el-table-column>
            <el-table-column prop="quantity" :label="$t('carbonIndex.ContractAddress')">
            </el-table-column>
            <el-table-column prop="quantity" :label="$t('carbonIndex.ReceiverAddress')">
            </el-table-column>
            <el-table-column prop="quantity" :label="$t('carbonIndex.NameOfReport')">
            </el-table-column>
        </el-table>
        <div class="display_flex dis_end" style="margin-top: 47px">
            <el-pagination
            v-if="tableData.length != 0"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            background
            layout="prev, pager, next"
            class="pagination"
            prev-text="<"
            next-text=">"
            :total="tableData.length"
            >
            </el-pagination>
        </div> -->
        </div>
    </div>
    
  </div>
</template>
<script>
import Headers from '@/components/header/index.vue'
import carbonRegistry from '@/api/carbonRegistry.js'
export default {
    components: {Headers},
    data() {
        return {
            tableData:[{
                id:111
            }],
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            pageSize: 10,
            currentPage: 1,
        };
    },
    //修改列表页的meta值，false时再次进入页面会重新请求数据。
    beforeRouteLeave(to, from, next) {
        if (to.path == "/carbon") {
            to.meta.keepAlive = true;
        } 
        next();
    },
    mounted(){
        let that = this;
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                that.windowWidth = document.documentElement.clientWidth, //实时屏幕宽度
                that.windowHeight = window.fullHeight; // 高
            })();
        };
    },
    methods: {
        columnStyle({ row, column, rowIndex, columnIndex}){
            if(columnIndex == 1){
                return "color:#366F67;word-break:break-word;padding-left:20px";
            }
            return "word-break:break-word;padding-left:20px";
        },
        gotoback(){
            this.$router.back()
        },
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
    },
};
</script>
<style lang="scss" scoped>
.detail{
    width: 1440px;
    max-width: 1440px;
    margin: 0 auto;
    padding-bottom: 50px;
}
.nfdtTitle{
  font-size: 18px;
  margin: 20px 0;
}
.top_box{
        padding: 27px 0 40px 0;
        display: flex;
        .title1{
            font-size: 20px;
            font-family: ArialMT;
            color: #626262;
            line-height: 23px;
            cursor: pointer;
        }
        .title2{
            margin: 0 10px;
            font-size: 20px;
            cursor: pointer;
        }
        .title3{
            font-size: 20px;
            font-family: ArialMT;
            color: #1E1E1E;
            line-height: 23px;
            cursor: pointer;
        }
        .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
            font-size: 20px;
            font-family: ArialMT;
            color: #626262;
            line-height: 23px;
        }
        .el-breadcrumb__inner{
            font-size: 20px;
            font-family: ArialMT;
            color: #1E1E1E;
            line-height: 23px;
        }
        .el-breadcrumb{
            font-size: 20px;
        }
    }
.tabel_box{
    width: 1440px;
    tr{
        th{
            width: 200px;
            padding: 10px 0;
        }
        td{
            padding-left: 15px;
        }
    }
}
</style>